import {ReactElement} from "react";
import {Navbar} from "react-bootstrap";
import {ThemeProvider} from "@zendeskgarden/react-theming";
import "./NavBar.scss";
import brand from "../../assets/icons/brand/brand.png";
import {ViziblyTheme} from "../../styles/zendesk-garden/ViziblyZDGTheme";
import {LogoutButton} from "./components/logout-button/LogoutButton";

export function UserManagerNavBar(): ReactElement {
    return (
        <Navbar className="vz-header" bg="light">
            <Navbar.Brand href="/"><img src={brand} alt="vizibly-brand" className="vizibly-brand" /></Navbar.Brand>
            <div className="me-auto" />
            <ThemeProvider theme={ViziblyTheme}>
                <LogoutButton />
            </ThemeProvider>
        </Navbar>
    );
}
